import React from 'react'
import { isMobile } from 'react-device-detect'
import { faCheck, faPlus, faXmark } from '@fortawesome/free-solid-svg-icons'
import ProfileSection from 'app/common/pixel-menu/_comp/ProfileSection'
import {
  DcBreadcrumbs,
  DcButton,
  DcFlexBox,
  PixelIcon,
  PixelModal,
  PixelPageContainer,
  PixelTable,
  Section,
  SectionContent,
} from 'pixel-base'

import { get } from 'utils/api-routes.util'

import AddNewPaymentMethod from './component/AddnewPaymentMethod'
import StoreLogos from '../../../admin/pages/stores/components/StoreLogos'

const columns = [
  {
    dataKey: 'store_id',
    name: 'Store',
    selector: (row) => <StoreLogos store_type={row.ecom_store_type} />,
  },
  {
    dataKey: 'store_name',
    name: 'Store ',
    sortable: true,
    selector: (row) => (row.store_name ? row.store_name : '--'),
  },
  {
    dataKey: 'title',
    name: 'Title ',
    sortable: true,
    wrap: true,
    maxWidth: '320px',
    selector: (row) => (row.title ? row.title : '--'),
  },

  {
    dataKey: 'enabled',
    name: 'Enabled',
    sortable: true,
    selector: (row) => (
      <PixelIcon
        color={row.enabled === '1' ? 'green' : 'red'}
        icon={row.enabled === '1' ? faCheck : faXmark}
      />
    ),
  },

  {
    dataKey: 'is_default',
    name: 'Is Default ?',
    sortable: true,
    selector: (row) => (
      <PixelIcon
        color={row.is_default === '1' ? 'green' : 'red'}
        icon={row.is_default === '1' ? faCheck : faXmark}
      />
    ),
  },
  {
    dataKey: 'last_synced_at',
    name: 'Last Synced At',
    sortable: true,
    selector: (row) => (row.last_synced_at ? row.last_synced_at : '--'),
  },
  {
    dataKey: 'is_online_payment',
    name: 'Is Online Payment',
    sortable: true,
    selector: (row) => (
      <PixelIcon
        color={row.is_online_payment === '1' ? 'green' : 'red'}
        icon={row.is_online_payment === '1' ? faCheck : faXmark}
      />
    ),
  },
]
const breadcrumbs = [
  {
    name: 'Payment Gateways',
    active: true,
  },
]

const PaymentGateways = () => {
  const [showNewModal, setShowNewModal] = React.useState(false)
  const [tableLoading, setTableLoading] = React.useState(true)

  const [gateways, setGateways] = React.useState<any>([])
  const readData = () => {
    setTableLoading(true)
    get('/settings/payment-gateways').subscribe((res: any) => {
      setGateways(res.response.data)
      setTableLoading(false)
    })
  }
  React.useEffect(() => {
    readData()
  }, [])
  const handleCloseModal = (data: any) => {
    setGateways([data, ...gateways])
    setShowNewModal(false)
  }
  return (
    <>
      <DcFlexBox
        height="60px"
        fontSize="16px"
        style={{
          fontSize: '16px',
          padding: '8px 0px',
          borderBottom: '1px solid #e5e5e5',
        }}
      >
        <DcFlexBox
          justifyContent="space-between"
          alignItems="center"
          padding=".5rem 20px"
        >
          <DcBreadcrumbs fontSize="16px" data={breadcrumbs} />

          <ProfileSection />
        </DcFlexBox>
      </DcFlexBox>

      <PixelPageContainer padding="0px">
        <Section style={{ padding: '0px' }} isMobile={isMobile}>
          <SectionContent
            style={{ padding: '0px', borderRadius: '0px' }}
            isMobile={isMobile}
          >
            <DcFlexBox
              justifyContent="flex-end"
              height="auto"
              padding="5px 20px"
            >
              <DcButton
                onClick={() => {
                  setShowNewModal(true)
                }}
                size="sm"
              >
                <PixelIcon icon={faPlus} color="#fff" /> Add{' '}
                {!isMobile && 'Payment Gateway'}
              </DcButton>
            </DcFlexBox>
          </SectionContent>
        </Section>
        <Section style={{ padding: '20px' }} isMobile={isMobile}>
          <SectionContent isMobile={isMobile}>
            <PixelTable
              columns={columns}
              data={gateways}
              progressPending={tableLoading}
              fixedHeader={true}
              fixedHeaderScrollHeight="calc(100vh - 211px)"
            />
          </SectionContent>
        </Section>
      </PixelPageContainer>
      <PixelModal
        title={'Add Payment Method'}
        handleClose={() => setShowNewModal(false)}
        show={showNewModal}
      >
        {showNewModal && <AddNewPaymentMethod handleClose={handleCloseModal} />}
      </PixelModal>
    </>
  )
}

export default PaymentGateways
